import axios from 'axios'

export default {
  getUsers(params) {
    //console.log('getUsers: '+JSON.stringify(params,null,2))
    return axios.get(`/users/all/${params.identity}`, {
      params
    })
  },
  editUser(id, payload) {
    return axios.patch(`/users/${id}`, payload)
  },
  saveUser(payload) {
    return axios.post('/users/', payload)
  },
  deleteUser(id) {
    return axios.delete(`/users/${id}`)
  }
}
